module.exports = __webpack_public_path__ + "static/img/cultrue1.98fcac9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cultrue1.jpg
// module id = Dr35
// module chunks = 1